import { toast } from "sonner";
import type { ErrorCode } from "#shared/errors/registry.ts";
import { resolveError } from "./resolveError.ts";
import { copyProblemReport } from "./problemReport.ts";

/**
 * Transient action failures (save, bulk edit) — toast with optional Retry.
 * Connection-level problems should use the banner instead.
 */
export function notifyError(
  err: unknown,
  opts?: {
    fallbackCode?: ErrorCode;
    actionLabel?: string;
    onRetry?: () => void;
  },
): void {
  const resolved = resolveError(err, opts?.fallbackCode ?? "SAVE_FAILED");
  const retryable =
    resolved.definition.action.kind === "retry" || opts?.onRetry !== undefined;

  toast.error(resolved.message, {
    description:
      resolved.errorId &&
      `${resolved.code === "UNKNOWN" || resolved.code === "SAVE_FAILED" ? resolved.code + " · " : ""}Ref ${resolved.errorId}`,
    action:
      retryable && opts?.onRetry
        ? {
            label: "Retry",
            onClick: () => opts.onRetry?.(),
          }
        : {
            label: "Copy",
            onClick: () => {
              void copyProblemReport({
                errorId: resolved.errorId,
                code: resolved.code,
                message: resolved.message,
                action: opts?.actionLabel,
              }).catch(() => {
                /* clipboard may be denied */
              });
            },
          },
  });
}
